import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// The whole site is dark ("iron + ember"), so Vuetify's own components
// (dialogs, inputs, menus, snackbars) use the dark theme with ember accents.
export default new Vuetify({
  theme: {
    dark: true,
    options: { customProperties: true },
    themes: {
      dark: {
        primary: '#FF7A45',
        secondary: '#FFB07A',
        accent: '#D9501E',
        error: '#F06A6E',
        warning: '#FFB07A',
        info: '#8A94A6',
        success: '#4ADE80',
        background: '#0A0E14',
        surface: '#151B25'
      }
    }
  }
});
